import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";

import { WhiteOutline } from "Components/Buttons/Buttons";
import Slick from "react-slick";
import PropTypes from "prop-types";
import styles from "./styles/home-listings.scss";

const production = process.env.NODE_ENV === "production";

const PrevArrow = props => {
  const { onClick } = props;
  return (
    <button type="button" className={`${styles.prevButton}`} onClick={onClick}>
      <i className="fa fa-chevron-left" />
    </button>
  );
};
PrevArrow.propTypes = {
  onClick: PropTypes.func.isRequired
};
const NextArrow = props => {
  const { onClick } = props;
  return (
    <button type="button" className={`${styles.nextButton}`} onClick={onClick}>
      <i className="fa fa-chevron-right" />
    </button>
  );
};
NextArrow.propTypes = {
  onClick: PropTypes.func.isRequired
};
const BackgroundSlide = props => {
  const { id, img } = props;
  return (
    <img key={id} className={styles.slide} src={`/image/${img}/1800`} alt="" />
  );
};
BackgroundSlide.propTypes = {
  id: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired
};
const CustomButton = props => {
  const { i, onClick, active } = props;
  return (
    <button
      type="button"
      className={`${styles.dot} ${active ? styles.active : ""}`}
      onClick={() => onClick(i)}
    >
      <span>Slide {i + 1}</span>
    </button>
  );
};
CustomButton.propTypes = {
  i: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired
};

class Listings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bgSlider: null,
      captionSlider: null,
      slideIndex: 0
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToSlide = this.goToSlide.bind(this);
  }

  componentDidMount() {
    this.setState({
      bgSlider: this.bgSlider,
      captionSlider: this.captionSlider
    });
  }

  next() {
    this.captionSlider.slickPause();
    this.captionSlider.slickNext();
  }

  previous() {
    this.captionSlider.slickPause();
    this.captionSlider.slickPrev();
  }

  goToSlide(index) {
    this.captionSlider.slickPause();
    this.captionSlider.slickGoTo(index);
  }

  render() {
    const { bgSlider, captionSlider, slideIndex } = this.state;
    const { settings, listings, heading } = this.props;

    const sharedSettings = {
      speed:
        settings && settings["Slideshow Speed"]
          ? +settings["Slideshow Speed"]
          : 1000,
      autoplaySpeed:
        settings && settings["Slideshow Delay"]
          ? +settings["Slideshow Delay"]
          : 5000,
      initialSlide: 0,
      infinite: true,
      arrows: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    const bgSettings = {
      fade: false,
      autoplay: false,
      ...sharedSettings
    };

    const captionSettings = {
      fade: true,
      autoplay: true,
      beforeChange: (current, next) => this.setState({ slideIndex: next }),
      ...sharedSettings
    };

    return (
      <div className={styles.wrapper}>
        <Slick
          {...bgSettings}
          asNavFor={captionSlider}
          ref={slider => (this.bgSlider = slider)}
          className={`${styles.bgSlider}`}
        >
          {listings.map((listing, index) => {
            const { id } = listing;
            return <BackgroundSlide {...listing} key={id} />;
          })}
        </Slick>
        <div className={styles.gradient} />
        <div className={styles.container}>
          <section className={styles.captionWrapper}>
            <h2 className={styles.heading}>{heading}</h2>

            <Slick
              {...captionSettings}
              asNavFor={bgSlider}
              ref={slider => (this.captionSlider = slider)}
              className={`${styles.captionSlider}`}
            >
              {listings.map(listing => {
                const { id, title, html, featured_text, slug, profileSlug} = listing;
                return (
                  <Fragment key={id}>
                    <p className={styles.title}>{title}</p>
                    {featured_text ? (
                      <p className={styles.description}>{featured_text}</p>
                    ) : (
                      <div
                        className={styles.description}
                        dangerouslySetInnerHTML={{ __html: html }}
                      />
                    )}
                    <WhiteOutline text="View Listing" link={profileSlug} />
                  </Fragment>
                );
              })}
            </Slick>
            <nav className={styles.controls}>
              {listings.length > 1 && (
                <Fragment>
                  <PrevArrow onClick={this.previous} />
                  {listings.map((listing, index) => {
                    const { id } = listing;
                    return (
                      <CustomButton
                        key={id}
                        i={index}
                        onClick={this.goToSlide}
                        active={index === slideIndex}
                      />
                    );
                  })}
                  <NextArrow onClick={this.next} />
                </Fragment>
              )}
            </nav>
          </section>
        </div>
      </div>
    );
  }
}
Listings.propTypes = {
  settings: PropTypes.object.isRequired,
  listings: PropTypes.array.isRequired,
  heading: PropTypes.string.isRequired
};

export default Listings;

if (PRODUCTION && document) {
  const headerJSON = JSON.parse(
    document.getElementById("homeListingsData").innerHTML
  );
  const config = {
    ...headerJSON
  };

  ReactDOM.render(
    <Listings {...config} />,
    document.getElementById("homeListings")
  );
}
